function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "\n    cms-richtext\n  ");

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M37.9,9.31H20.41a1.13,1.13,0,1,1,0-2.25H37.9a1.13,1.13,0,1,1,0,2.25Z",
  fill: "#231f20"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M37.9,17.4H20.41a1.13,1.13,0,1,1,0-2.25H37.9a1.13,1.13,0,1,1,0,2.25Z",
  fill: "#231f20"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M37.9,25.49H2a1.13,1.13,0,0,1,0-2.25H37.9a1.13,1.13,0,1,1,0,2.25Z",
  fill: "#231f20"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M37.9,33.59H2a1.13,1.13,0,0,1,0-2.25H37.9a1.13,1.13,0,1,1,0,2.25Z",
  fill: "#231f20"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M5.94,9.26H2.53A.53.53,0,0,1,2,8.73v-2a.53.53,0,0,1,.53-.53H14.07a.52.52,0,0,1,.52.53v2a.52.52,0,0,1-.52.53H10.66a.52.52,0,0,0-.53.52v8.33a.53.53,0,0,1-.53.53H7a.52.52,0,0,1-.52-.53V9.78A.52.52,0,0,0,5.94,9.26Z",
  fill: "#231f20"
});

function SvgCmsRichtext(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 40 40"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6);
}

export default SvgCmsRichtext;